export const VISIBILITY_TYPES = {
    ALL: 'all',
    OPEN: 'open',
    DONE: 'done'
}
